import { pluralize } from '@/utils/helpers'

import type { SeriesTimeInfo } from './types'

export default function seriesTimeInfoToString({
  timeInfo,
  includeTimezone = false,
}: {
  timeInfo: SeriesTimeInfo[]
  includeTimezone?: boolean
}): string {
  return timeInfo
    .map(
      ({ dayLabel, time, timezone, numOccurrences }) =>
        `${pluralize(numOccurrences, dayLabel, { unitsOnly: true })} ${time}${includeTimezone ? ` ${timezone}` : ''}`
    )
    .join(', ')
}
